import {countryData, CountryData, filtering} from '@malwarebytes/geography-library'
const {RemoveNotSupported, FiltersPipe} = filtering

export const countries = new FiltersPipe<CountryData>([new RemoveNotSupported()]).filter(countryData)
